import { IOrder, IPremadeQuiz } from '@quizzach/interfaces';
import { fetchData, consoleDev, ConsoleStatus } from '@quizzach/utils';
import { useState } from 'react';

import { generateMockOrder } from './order.mock';
import { MOCK_ORDER } from './mocks.config';

export const useOrder = () => {
	const [order, setOrder] = useState<IOrder>();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);

	const getOrder = async (uuid: string) => {
		setLoading(true);
		if (MOCK_ORDER) {
			// real premades feed the mock so the rows carry real cover art;
			// small artificial latency keeps the skeleton state visible
			const quizzes = await fetchData<IPremadeQuiz[]>(`/api/premade-quizzes`, {
				method: 'GET',
			});
			await new Promise((resolve) => setTimeout(resolve, 800));
			setOrder(generateMockOrder(quizzes.data || []));
			setLoading(false);
			return;
		}
		try {
			const response = await fetchData<IOrder>(
				`/api/orders/${uuid}`,
				{
					method: 'GET',
				},
				{
					authRoute: true,
				}
			);
			if (response.status >= 300) {
				consoleDev('order', ConsoleStatus.HTTP, response.status);
				setError(true);
			}
			if (response.data) {
				consoleDev('order', ConsoleStatus.SUCC);
				setOrder(response.data);
			}
		} catch (err) {
			consoleDev('order', ConsoleStatus.NET, err);
			setError(true);
		} finally {
			setLoading(false);
		}
	};

	return {
		order,
		loading,
		error,
		getOrder,
	};
};
